$(function(){

  // スムーズスクロール
  $('a[href^="#"]').click(function () {
    var href = $(this).attr("href");
  
    // フォーム切り替え用途のIDを除外
    const excludeList = ['#recover', '#login', '#create_customer'];
    if (excludeList.includes(href)) return;
  
    var speed = 400;
    var target = $(href === "#" || href === "" ? "html" : href);
    var position = target.offset().top;
    $("body,html").animate({ scrollTop: position }, speed, "swing");
    return false;
  });

  //スマホのみ電話リンクを付与
  var ua = navigator.userAgent;
  if (ua.indexOf("iPhone") > 0 || (ua.indexOf("Android") > 0 && ua.indexOf("Mobile") > 0)) {
    $(".tel_link").each(function () {
      var tel = $(this);
      var html = tel.html();
      var teltext = tel.text();
      var telnum = teltext.replace(/[^0-9]/g, "");
      tel.html(
        $("<a>")
          .attr("href", "tel:" + telnum)
          .append(html)
      );
    });
  }


  //TOPページFVスライダー
  // const swiper = new Swiper(".swiper", {
  //   loop: true,
  //   effect: 'fade',
  //   speed: 2000,
  //   autoplay: {
  //     delay: 3000,
  //   },
  //   allowTouchMove: false,
  //   pagination: {
  //     el: ".swiper-pagination",
  //     clickable: true,
  //   }
  // });


  // ナビゲーションメニュー
  $('.nav_btn').click(function () {
    $('.nav_box').toggleClass('active');
    $(this).toggleClass('active');

    // if ($(this).hasClass('active')) {
    //   $('body').addClass('fixed');
    // } else {
    //   $('body').removeClass('fixed');
    // }
  });
  $(document).on('click', function (e) {
    if ($('.nav_btn').hasClass('active')) {
      if (!$(e.target).closest('.nav_box, .nav_btn').length) {
        $('.nav_box').removeClass('active');
        $('.nav_btn').removeClass('active');
      }
    }
  });



  // 検索モーダル
  var open = $('.search_btn'),
    close = $('.modal_close'),
    container = $('.modal_search');

  open.on('click',function(){ 
    container.addClass('active');
    return false;
  });

  close.on('click',function(){  
    container.removeClass('active');
  });
  $(document).on('click',function(e) {
    if(!$(e.target).closest('.modal_inner').length) {
      container.removeClass('active');
    }
  });

  // ABOUTページ スライダー
  let about_swiper;

  function initAboutSwiper() {
    if ($(window).width() > 768 && !about_swiper) {
      about_swiper = new Swiper(".about_swiper", {
        loop: true,
        speed: 700,
        effect: 'fade',
        slidesPerView: 'auto',
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        fadeEffect: {
          crossFade: true,
        },
      });
    } else if ($(window).width() <= 768 && about_swiper) {
      about_swiper.destroy(true, true);
      about_swiper = null;
    }
  }

  // ページロード時とリサイズ時に実行
  $(document).ready(function() {
    initAboutSwiper();
    $(window).resize(function() {
      initAboutSwiper();
    });
  });


  //FAQアコーディオン
  if ($(".question").length) {
    $(".answer").hide();

    $(".question.active").each(function () {
      $(this).next(".answer").show();
    });

    $(".question").click(function () {
      if ($(this).hasClass("active")) {
        $(this).removeClass("active");
        $(this).next(".answer").slideUp(400);
      } else {
        $(this).addClass("active");
        $(this).next(".answer").slideDown(400);
      }
    });
  }

  if ($(".js-scrollable").length) {
    // スクロールヒントの初期化
    new ScrollHint(".js-scrollable", {
      scrollHintIconAppendClass: "scroll-hint-icon-black", // black-icon will appear
      applyToParents: true,
      i18n: {
        scrollable: "スクロールできます",
      },
    });
  }

  window.addEventListener("load", function () {
    const updatePrice = () => {
      document.querySelectorAll(".price-item.price-item--regular").forEach(function (el) {
        let text = el.textContent.trim();
        text = text.replace(/AUD/g, "").trim();
        if (!text.endsWith("〜(税込)")) {
          el.textContent = text + "〜(税込)";
        }
      });
    };
    updatePrice();
    // 念のため遅延してもう一度（Shopifyが後から書き換える場合に対応）
    setTimeout(updatePrice, 500);
  });
  
});
